import type { AuditTrailGetRequestDto } from './dto/auditTrail-get.request.dto.js';

export enum AuditTarget {
  Matter = 'matter',
  Subset = 'subset',
}

export enum AuditVerb {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',

  AddedUser = 'added user',
  RemovedUser = 'removed user',
}
export enum AuditEventType {
  // Matter
  CreatedMatter = `${AuditVerb.Created}-${AuditTarget.Matter}`,
  UpdatedMatter = `${AuditVerb.Updated}-${AuditTarget.Matter}`,
  DeletedMatter = `${AuditVerb.Deleted}-${AuditTarget.Matter}`,
  // User matter
  AddedUserMatter = `${AuditVerb.AddedUser}-${AuditTarget.Matter}`,
  RemovedUserMatter = `${AuditVerb.RemovedUser}-${AuditTarget.Matter}`,

  // Subset
  CreatedSubset = `${AuditVerb.Created}-${AuditTarget.Subset}`,
  UpdatedSubset = `${AuditVerb.Updated}-${AuditTarget.Subset}`,
  DeletedSubset = `${AuditVerb.Deleted}-${AuditTarget.Subset}`,
}

// Union of all potential types with auditEventType as the discriminator
export type AuditDetail = AddedRemovedUser;

type AddedRemovedUser = {
  auditEventType: AuditEventType.AddedUserMatter | AuditEventType.RemovedUserMatter;
  targetUserEmail: string;
};

// // Example for additional type for detail
// type AddedRemovedDocs = {
//   auditEventType: AuditEventType.
//   targetUserEmail: string;
// }

export type AuditTrailFilters = Partial<AuditTrailGetRequestDto>;

export const AUDIT_TRAIL_SORTABLE_COLUMNS = ['eventDate', 'auditEventType', 'user'];
